import { useLocation, } from "react-router-dom";

export const RETURN_TO_QUERY = "returnTo";

export function appendReturnTo(path: string, returnTo: string | null): string {
  if (!returnTo) return path;

  const [pathname, search = "",] = path.split("?",);
  const params = new URLSearchParams(search,);
  params.set(RETURN_TO_QUERY, returnTo,);
  return `${pathname}?${params.toString()}`;
}

export function getReturnToFromUrl(url: string): string | null {
  try {
    return new URL(url,).searchParams.get(RETURN_TO_QUERY,);
  } catch (_e) {
    return null;
  }
}

export function useReturnTo() {
  const { search, } = useLocation();
  const returnTo = new URLSearchParams(search,).get(RETURN_TO_QUERY,);

  return {
    returnTo,
    withReturnTo: (path: string) => appendReturnTo(path, returnTo,),
  };
}
